import { chain, ifElse, isNil, map, pipe } from "ramda";
import { of, throwError } from "most";
import { combineArray, recoverWith } from "common/mostCurried";
import { combineEpics, select, withState } from "redux-most";
import { fetchOrganizationByAlias } from "common/authAjax";
import {
  fetchAudioTypes,
  fetchDocumentMediumFormats,
  fetchImageMediumFormats,
  fetchProject,
} from "common/stipAjax";
import { APP_STARTED, appError, appDataLoaded } from "./applicationActions";
import {
  isValidRoute,
  parseProjectKey,
  parseOrganizationAlias,
  parseProgramKey,
} from "common/urlHelpers";
import { getUserLanguage } from "../common/selectors";

const getProjectKeyFromUrl = () => parseProjectKey(window.location.href);
const getProgramKeyFromUrl = () => parseProgramKey(window.location.href);

const getOrganizationAliasFromUrl = () =>
  parseOrganizationAlias(window.location.href);

const fetchOrganization = pipe(
  getOrganizationAliasFromUrl,
  ifElse(isNil, of, fetchOrganizationByAlias),
);

const checkRoute = () => {
  const { href } = window.location;

  return isValidRoute(href) ? of(href) : throwError(new Error("Invalid url"));
};

const fetchAppData = ([state]) => {
  return combineArray(
    (
      project,
      organization,
      documentMediumFormats,
      imageMediumFormats,
      audioTypes,
    ) => ({
      project,
      organization,
      documentMediumFormats,
      imageMediumFormats,
      audioTypes,
    }),
    [
      fetchProject(
        getProgramKeyFromUrl(),
        getProjectKeyFromUrl(),
        getUserLanguage(state),
      ),
      fetchOrganization(),
      fetchDocumentMediumFormats(),
      fetchImageMediumFormats(),
      fetchAudioTypes(),
    ],
  );
};

const appStartEpic = (action$, state$) =>
  pipe(
    select(APP_STARTED),
    chain(
      pipe(
        checkRoute,
        withState(state$),
        chain(fetchAppData),
        map(appDataLoaded),
        recoverWith(pipe(appError, of)),
      ),
    ),
  )(action$);

export default combineEpics([appStartEpic]);
